import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button } from "@mui/joy";
import { getFetch } from "../../../../../../fetch/fetch";
import styles from "./callhistory.module.css";
import { formatCallTime } from "./callhistoryformat";

const pad = (n : number) => (n < 10 ? "0" + n : String(n));
const msToClock = (ms : number) => {
    const s = Math.floor((ms || 0) / 1000);
    return `${pad(Math.floor(s / 60))}:${pad(s % 60)}`;
};

//전문 모달: 요약(topic/points/nextAction) + 화자별 발화 (transcriptText 의 줄바꿈 유지)
const TranscriptModal : React.FC<any> = (props) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>("");
    const [transcript, setTranscript] = useState<any>(null);

    useEffect(() => {
        if (!props.open || !props.call) {
            return;
        }
        setTranscript(null);
        setError("");
        setLoading(true);
        getFetch(`/dashboard/callcenter/history/calls/transcript?callId=${encodeURIComponent(props.call.callId)}`)
            .then((result : any) => {
                if (result.message === "success") {
                    setTranscript(result.transcript);
                } else {
                    setError(result.message === "noTranscript" ? "전사 결과가 아직 없습니다" : "전문을 불러오지 못했습니다");
                }
            })
            .catch((e : any) => {
                console.log(e);
                setError("전문을 불러오지 못했습니다");
            })
            .then(() => setLoading(false));
    }, [props.open, props.call]);

    const call = props.call;
    if (!call) {
        return null;
    }
    const summary = transcript && transcript.summary;
    const utterances : any[] = transcript && Array.isArray(transcript.utterances) ? transcript.utterances : [];

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "720px", maxWidth: "90vw" }}>
                    <div className={styles.modalTitle}>
                        통화 전문
                        <span style={{ fontSize: "13px", color: "#6B7280", marginLeft: "10px", fontFamily: "Apple_R" }}>
                            {formatCallTime(call.startedAt)}{call.agentName ? ` · ${call.agentName}` : ""}{call.queueName ? ` · ${call.queueName} 큐` : ""}
                        </span>
                    </div>
                    {
                        loading ? <div style={{ color: "#9AA1AB", fontSize: "13px", padding: "20px 0" }}>불러오는 중...</div>
                        : error ? <div className={styles.modalError}>{error}</div>
                        :
                        <div>
                            {
                                summary && summary.topic ?
                                    <div className={styles.transcriptSummary}>
                                        <div className={styles.summaryTopic}>{summary.topic}</div>
                                        {
                                            Array.isArray(summary.points) ?
                                                summary.points.map((p : string, i : number) => <div key={i}>· {p}</div>)
                                                : ""
                                        }
                                        {summary.nextAction ? <div className={styles.summaryNext}>다음: {summary.nextAction}</div> : ""}
                                    </div>
                                    : ""
                            }
                            <div className={styles.transcriptBody}>
                                {
                                    utterances.length > 0 ?
                                        utterances.map((u : any, i : number) => (
                                            <div key={i} className={styles.utterance}>
                                                <span className={styles.utteranceTime}>{msToClock(u.start_at)}</span>
                                                <span>
                                                    <span className={(+u.spk || 0) === 0 ? styles.speakerA : styles.speakerB}>화자{String.fromCharCode(65 + (+u.spk || 0))}</span>
                                                    {" "}{u.msg}
                                                </span>
                                            </div>
                                        ))
                                        :
                                        (transcript ? transcript.transcriptText : "")
                                }
                            </div>
                        </div>
                    }
                    <div className={styles.modalButtons}>
                        <Button variant="plain" color="neutral" onClick={props.onClose}>닫기</Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default TranscriptModal;
